export default __webpack_public_path__ + "static/media/twitter.b74e3109.svg";